<template>
  <div
    class="saffron-debug empty-div-to-prevent-errors"
    style="display: none"></div>
</template>

<script>
export default {
  components: {},
  props: {
    // eslint-disable-next-line vue/require-prop-types
    data: {
      // this can be any type
      default: null,
    },
    label: {
      type: [String, Boolean, undefined],
      default: false,
    },
    title: {
      type: [String, Boolean, undefined],
      default: false,
    },
    name: {
      type: [String, Boolean, undefined],
      default: false,
    },
    identifier: {
      type: [String, Number, null, undefined],
      default: undefined,
    },
    conf: {
      type: Object,
      default: {},
    },
    open: {
      type: [Boolean, String, Number],
      default: false,
    },
    show: {
      type: [Boolean, String, Number],
      default: false,
    },
  },
  data() {
    return {
      internalIdentifier: undefined,
    };
  },
  beforeUnmount() {
    this.$s.debug.remove(this.internalIdentifier);
  },
  watch: {
    data: {
      handler(newVal) {
        this.lazyCreateDebugItem();
      },
      deep: true,
    },
  },
  methods: {
    lazyCreateDebugItem() {
      let id = this.identifier ? this.identifier : this.internalIdentifier;

      let label = this.label;

      if (this.title) {
        label = this.title;
      }
      if (this.name) {
        label = this.name;
      }

      this.internalIdentifier = this.$s
        .debug(this.data, label, this.conf, id)
        .getLastIdentifier();
    },
    openIfRequired() {
      if (
        this.open === true ||
        this.open === "true" ||
        this.open === 1 ||
        this.open === "1" ||
        this.open === "True" ||
        this.open === "TRUE" ||
        this.show === true ||
        this.show === "true" ||
        this.show === 1 ||
        this.show === "1" ||
        this.show === "True" ||
        this.show === "TRUE"
      ) {
        this.$s.debug.open();
      }
    },
  },
  mounted() {
    this.lazyCreateDebugItem();
    this.openIfRequired();
  },
};
</script>
